/** The rates the OTT Playback Speed panel offers, in the order it lists them. */
export const PLAYBACK_RATES = [0.5, 0.75, 1, 1.25, 1.5, 2] as const

export type PlaybackRate = (typeof PLAYBACK_RATES)[number]

export const DEFAULT_PLAYBACK_RATE: PlaybackRate = 1

/**
 * `loading` covers everything before the first frame is decodable, including a
 * mid-playback stall, because the chrome treats both the same way: show a
 * spinner and keep the controls up.
 */
export type PlayerStatus = "loading" | "playing" | "paused" | "ended" | "failed"

export interface CaptionState {
  /** False until the player reports a caption track, which can be after playback starts. */
  readonly isAvailable: boolean
  readonly isEnabled: boolean
}

export interface PlayerState {
  readonly status: PlayerStatus
  readonly currentSeconds: number
  /**
   * The player's own duration once it knows one, falling back to the graph's.
   * Zero while both are still unknown — the scrub bar reads that as "no track
   * yet" and draws itself empty rather than dividing by zero.
   */
  readonly durationSeconds: number
  readonly bufferedSeconds: number
  readonly rate: PlaybackRate
  readonly captions: CaptionState
}

export interface PlayerCommands {
  readonly play: () => void
  readonly pause: () => void
  readonly togglePlay: () => void
  readonly seekTo: (seconds: number) => void
  /** Relative seek, in seconds. Negative rewinds. */
  readonly skip: (deltaSeconds: number) => void
  readonly setRate: (rate: PlaybackRate) => void
  readonly toggleCaptions: () => void
}
